import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Flex, Link, Text } from '@chakra-ui/react';
import { CardMedia } from '../CardMedia';
import { RichText } from '../RichText';

function FeaturedCard({ data, useWindowMouseEvents }) {
  const { section, aspectRatio } = data;
  const { section: sectionArea, slug, title, excerpt, parallaxHero } = section;

  return (
    <Link
      to={`/${sectionArea === 'single' ? '' : `${sectionArea}/`}${slug.current}`}
      as={GatsbyLink}
      _hover={{
        textDecoration: 'none',
        color: 'navy',
      }}
      width='100%'
      height='100%'
      aria-label={title}
      role='group'
    >
      <Flex
        direction='column'
        justifyContent='center'
        alignItems='center'
        gap={4}
        position='relative'
        height='100%'
      >
        <Flex direction='column' alignItems='start' gap={2.5} width='100%'>
          <Flex
            direction='column'
            alignItems='start'
            justifyContent='center'
            gap={2.5}
            width='100%'
          >
            {parallaxHero?.richTitle ? (
              <RichText
                value={parallaxHero.richTitle}
                width='100%'
                fontSize={{ base: '3xl', lg: '5xl' }}
                color='inherit'
                lineHeight='1'
                textAlign='center'
              />
            ) : (
              <Text
                width='100%'
                fontSize={{ base: '3xl', lg: '5xl' }}
                fontWeight='bold'
                color='inherit'
                lineHeight='1'
                textAlign='center'
              >
                {title}
              </Text>
            )}
            {excerpt && (
              <Text
                width='100%'
                fontSize={{ base: 'md', lg: 'lg' }}
                fontWeight='normal'
                color='black'
                lineHeight='base'
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 3,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                textAlign='center'
              >
                {excerpt}
              </Text>
            )}
          </Flex>
        </Flex>
        <CardMedia
          data={section}
          aspectRatio={aspectRatio}
          useWindowMouseEvents={useWindowMouseEvents}
        />
      </Flex>
    </Link>
  );
}

export default FeaturedCard;
